<template>

  <v-btn
    :color="color"
    :disabled="disabled"
    elevation="0"
    v-bind="computedProps"
    v-on="$listeners"
    small>
    <v-icon>{{ icon }}</v-icon>
  </v-btn>

</template>
<script>
import { VBtn } from 'vuetify/lib'

/**
 * @file DDv2用標準アイコンボタン
 * @namespace components
 */

/**
 * @vue-event {Object} click
 * @vue-prop {String} icon - 指定アイコン
 * @see https://vuetifyjs.com/ja/api/v-btn/
 * @see https://materialdesignicons.com/
 * @example
  <dd-icon-button
    [atmark]click="onShowDialogButtonClick"
    icon="mdi-magnify"
    color="blue"/>
 */
export default {
  name: 'DdIconButton',
  extends: VBtn,
  props: {
    /**
     * 指定アイコン
     */
    icon: String,
    /**
     * カラー
     */
    color: {
      type: String
    },
    /**
     * 使用可否
     */
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
  }),
  mounted: function () {
  },
  computed: {
    computedProps () {
      return {
        ...this.$props,
        icon: true
      }
    }
  },
  methods: {
  }
}
</script>
<style scoped>
</style>
